import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { showModal } from 'store/main/ducks/modal';
import { subscribeToSubsite } from 'store/main/ducks/subscribedSubsites';
import { getParam } from 'utils/url';

type OwnProps = {
  subsiteId: string;
  render: (arg0: {
    subscribe: () => void;
    isSubscribed: boolean;
    submitting: boolean;
  }) => ReactNode;
};
type Props = OwnProps;

const SubscribeToSubsiteContainer = ({ subsiteId, render }: Props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentUser, subscribedSubsites } = useSelector((state) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'currentUser' does not exist on type 'Def... Remove this comment to see the full error message
    currentUser: state.currentUser,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'subscribedSubsites' does not exist on ty... Remove this comment to see the full error message
    subscribedSubsites: state.subscribedSubsites,
  }));
  const isSubscribed = subscribedSubsites.subsiteIds.includes(subsiteId);
  const [submitting, setSubmitting] = useState(false);
  const subscribe = useCallback(() => {
    if (currentUser.id) {
      setSubmitting(true);
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'then' does not exist on type 'ThunkActio... Remove this comment to see the full error message
      dispatch(subscribeToSubsite(subsiteId)).then(() => {
        setSubmitting(false);
      });
    } else {
      dispatch(
        showModal('EMAIL_SIGNUP', {
          subscribedSubsite: subsiteId,
        })
      );
    }
  }, [currentUser.id, dispatch, subsiteId]);
  useEffect(() => {
    if (currentUser.isLoaded) {
      const initSubscribe = getParam(location, 'subscribe');

      if (initSubscribe) {
        subscribe();
      }
    }
  }, [currentUser.isLoaded, location, subscribe]);
  return render({
    subscribe,
    isSubscribed,
    submitting,
  });
};

// eslint-disable-next-line import/no-default-export
export default SubscribeToSubsiteContainer;
